import React from 'react';
import { Link } from 'react-router-dom';
import { Label, Table, Row, Col } from 'reactstrap';
import URI from 'urijs';
import { compact } from 'underscore';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

function GolfCourseResult({ record }) {
  const id = record.name.replace(/(\s)/g, '-');
  return (
    <Row className={cx(styles.result, BS.borderBottom, BS.mb3)}>
      <Col xs={12} sm={8} md={9} className={styles.detailsCol}>
        <h6>
          <Link to={URI(`/golf-course/${id}`).toString()}>{record.name}</Link>
        </h6>
        <p>
          {renderAddress(record)}
          <br />
          {renderPhone(record)}
        </p>
        <p
          dangerouslySetInnerHTML={{
            __html: record.description
          }}
        />
        <p>
          <Link to={URI(`/golf-course/${id}`).toString()}>
            View Details and Nearby Listings
          </Link>
        </p>
      </Col>
      <Col xs={6} sm={4} md={3} className={BS.alignSelfCenter}>
        {renderDetails(record)}
      </Col>
    </Row>
  );
}

function renderAddress({ address, city, state, zip }) {
  return compact([address, city, compact([state, zip]).join(', ')]).join(' ');
}

function renderPhone({ phone, proShopPhone }) {
  return `Phone: ${phone}`;
}

function renderDetails({ par, holes, courseLength, rating }) {
  return (
    <Table className={styles.detailsTable}>
      <tbody>
        <tr>
          <td>
            <Label>Par:</Label>
          </td>
          <td>{par}</td>
        </tr>
        <tr>
          <td>
            <Label># of Holes:</Label>
          </td>
          <td>{holes}</td>
        </tr>
        <tr>
          <td>
            <Label>Course Length:</Label>
          </td>
          <td>{courseLength}</td>
        </tr>
        <tr>
          <td>
            <Label>Course Rating:</Label>
          </td>
          <td>{rating}</td>
        </tr>
      </tbody>
    </Table>
  );
}

export default GolfCourseResult;



// WEBPACK FOOTER //
// ./src/containers/GolfCourseSearch/GolfCourseSearchResult.js